import React from 'react';

import styles from './OrderOrder.module.css'
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {Order} from "../../../../types/Order.interface.ts";
import {DeliveryType} from "../../../../types/Delivery.interface.ts";
import { getStatusDescription } from '../../../../utils/getOrderStatusDescription.ts';

interface Props {
    order: Order,
    getPaymentUrl: (orderId: number) => void,
}

export const OrderOrder: React.FC<Props> = ({order, getPaymentUrl}) => {

    const deliveryPrice = order.delivery.courierPrice;
    const transportCompanyPrice = order.delivery.transportCompanyPrice;

    const productsCount = () => {
        return order.products.reduce((p, n) => p + n.amount, 0)
    };


    return (
        <div className={styles.wrapper}>
            <div style={{display: "flex",}}>
                <h3 className={styles.title}>Ваш заказ №</h3> <div className={styles.subTitle}>{order.orderNumber}</div>
            </div>
            <div style={{display: "flex",}}>
                <h3 className={styles.title}>Статус:</h3> <div className={styles.subTitle}>{getStatusDescription(order)}</div>
            </div>
            <div className={styles.products}>
                <div className={styles.productsTitle}>Выбрано товаров</div>
                <div className={styles.productsCounter}>{productsCount()} шт.</div>
            </div>
            <div className={styles.outline}></div>
            <div className={styles.delivery}>
                <div className={styles.deliveryPayment}>
                    <div className={styles.deliveryPaymentWrapper}>
                        {
                            order.delivery.type === DeliveryType.courier
                            ? <>
                                {deliveryPrice
                                    ? <div className={styles.deliveryPaymentPrice}>
                                        <div>
                                            Доставка:
                                        </div>
                                        <div className={styles.deliveryPaymentPriceAmount}>
                                            {`${deliveryPrice} ₽`}
                                        </div>
                                    </div>
                                    : null
                                }
                            </>
                            : null
                        }
                        {
                            order.delivery.type === DeliveryType.shipping
                            ? <>
                                    {deliveryPrice
                                        ? <div className={styles.deliveryPaymentPrice}>
                                            <div>
                                                Доставка до ТК:
                                            </div>
                                            <div className={styles.deliveryPaymentPriceAmount}>
                                                {`${deliveryPrice} ₽`}
                                            </div>
                                        </div>
                                        : null
                                    }
                                {transportCompanyPrice
                                    ? <div className={styles.deliveryPaymentPrice}>
                                        <div>
                                            Доставка ТК {order.delivery.company && Object.keys(order.delivery.company).length ? `(${order.delivery.company.name})` : null}):
                                        </div>
                                        <div className={styles.deliveryPaymentPriceAmount}>
                                            {`${transportCompanyPrice} ₽`}
                                        </div>
                                    </div>
                                    : null
                                }
                            </>
                            : null
                        }

                        
                        {
                        order.paymentAmount > 0 
                        ? <>
                            <div className={styles.deliveryPaymentTotalPrice}>
                                <div className={styles.deliveryPaymentTotalPriceTitle}>
                                    Оплачено
                                </div>
                                <div className={styles.deliveryPaymentTotalPriceAmount}>
                                    {order.paymentAmount} ₽
                                </div>
                            </div>
                        </>
                        : null
                        }
                        {
                        order.remainingPaymentAmount > 0 
                        ? <>
                            <div className={styles.deliveryPaymentTotalPrice}>
                                <div className={styles.deliveryPaymentTotalPriceTitle}>
                                    Итого к оплате
                                </div>
                                <div className={styles.deliveryPaymentTotalPriceAmount}>
                                    {order.remainingPaymentAmount} ₽
                                </div>
                            </div>
                        </>
                        : null
                        }
                    </div>

                    <div className={styles.deliveryPaymentMethod}>
                        <div className={styles.deliveryPaymentMethodName}>
                            {order.paymentMethodName ?? 'Не выбран'}
                        </div>
                    </div>
                </div>

                {
                    order.delivery.type !== DeliveryType.pickup
                ? <>
                    <div className={styles.outline}/>
                    <div className={styles.deliveryInfo}>
                        <div className={styles.deliveryInfoTitle}>
                            Информация о доставке:
                        </div>
                        {order.delivery ? (<>
                            <div className={styles.deliveryType}>{order.delivery.typeName}</div>
                            <div className={styles.deliveryAdress}>{order.delivery.address}</div>
                            <div className={styles.outline}/>
                            {
                                order.delivery.date
                                ? <div className={styles.deliveryDateWrapper}>
                                    <div>
                                        Доставим:
                                    </div>
                                    <div className={styles.deliveryDate}>
                                        {order.delivery.date}
                                    </div>
                                </div>
                                : null
                            }
                        </>) : <div className={styles.deliveryInfoNotAvailable}>Отсутствует</div>}
                    </div>
                    </>
                    : null
                }
            </div>
            <Button
                disabled={order.remainingPaymentAmount === 0}
                type='regular'
                className={styles.btnOrder}
                id='order-btn'
                onClick={() => getPaymentUrl(order.orderId)}
            >
                {order.remainingPaymentAmount === 0 ? 'Оплачено' : 'Оплатить заказ'}
            </Button>
    </div>
    );
};